import api from 'config/api';

export const fetchAssets = () => (
  api.get('/api/assets')
);

export const fetchAssetsCurves = () => (
  api.get('/api/assetcurves')
);
